import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getChatApiRoute } from '@renderer/chat/api/v1Client'
import { useAuth } from '@renderer/chat/providers'
import { FOR_YOU_CHATS_QUERY_KEY } from '@renderer/stores/conversation-query-keys'

export function useClearForYouChat() {
  const { getAuthToken } = useAuth()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (conversationId: string) => {
      const token = await getAuthToken()
      // Archive only hides the row from For You (until new activity); the
      // conversation stays in Recents and history.
      const response = await fetch(getChatApiRoute(`api/v1/conversations/${conversationId}/archive`), {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      })
      if (!response.ok) {
        throw new Error(`Failed to clear conversation from For You: ${response.status}`)
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [FOR_YOU_CHATS_QUERY_KEY] })
    },
  })

  return { clearForYouChat: mutation.mutateAsync, isClearing: mutation.isPending }
}

export function useRestoreForYouChat() {
  const { getAuthToken } = useAuth()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (conversationId: string) => {
      const token = await getAuthToken()
      const response = await fetch(getChatApiRoute(`api/v1/conversations/${conversationId}/restore`), {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      })
      if (!response.ok) {
        throw new Error(`Failed to restore conversation to For You: ${response.status}`)
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [FOR_YOU_CHATS_QUERY_KEY] })
    },
  })

  return { restoreForYouChat: mutation.mutateAsync, isRestoring: mutation.isPending }
}
